import http from "@http"

//根据类型获取字典数据列表

// 用户性别
export function getUserSex(data) {
    return http({
        url: `/lskj-admin/api/admin/dictData/getType?type=${data.type}`,
        method: "get",
    })
}
//系统模块
export function getSystemModel(data) {
    return http({
        url: `/lskj-admin/api/admin/dictData/getType?type=${data.type}`,
        method: "get",
    })
}
// 数据类型
export function getDataType(data) {
    return http({
        url: `/lskj-admin/api/admin/dictData/getType?type=${data.type}`,
        method: "get",
    })
}
// 行别
export function getLineType(data) {
    return http({
        url: `/lskj-admin/api/admin/dictData/getType?type=${data.type}`,
        method: "get",
    })
}
// 图片浏览状态
export function getPictureBrowse(data) {
    return http({
        url: `/lskj-admin/api/admin/dictData/getType?type=${data.type}`,
        method: "get",
    })
}
// 线路类型
export function getCircuitType(data) {
    return http({
        url: `/lskj-admin/api/admin/dictData/getType?type=${data.type}`,
        method: "get",
    })
}